if (!customElements.get('show-more-toggle')) {
  customElements.define(
    'show-more-toggle',
    class ShowMoreToggle extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-show-more-content]');
        this.button = this.querySelector('button');
        if (!this.content || !this.button) return;

        // If the content fits within the max height, hide the toggle entirely.
        requestAnimationFrame(() => {
          if (this.content.scrollHeight <= this.content.clientHeight + 2) {
            this.button.style.display = 'none';
            this.content.classList.remove('content-truncated');
          }
        });

        this.button.addEventListener('click', () => {
          const expanded = this.classList.toggle('is-expanded');
          this.content.classList.toggle('content-truncated', !expanded);
          this.querySelector('.label-show-more')?.classList.toggle('hidden', expanded);
          this.querySelector('.label-show-less')?.classList.toggle('hidden', !expanded);
          this.button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
      }
    }
  );
}
